import './Loader.css';

const Loader = ({ className, text }) => {
    return (
        <div className={`flex flex-col justify-center items-center ${className ?? ''}`}>
            <div className="loader">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
            {text && <span>{text}</span>}
        </div>
    );
};

export default Loader;
